import { useState } from "react";

const ProjectCard = ({ title, cover, gif, url }) => {
    const [hover, setHover] = useState(false);

    return (
        <a href={url} target="_blank"  >
            <div className={`test my-4 bg-secondary-layer-2 border-2 border-black ${hover? "hoverbg":""}`}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)} 
                onTouchStart={()=>setHover(true)}
                onTouchEnd={()=>setHover(false)}
                >
                <div className="p-1 ">
                    <div className="w-full h-52 bg-center bg-no-repeat"
                        style={{ backgroundImage: `url(${cover})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}
                    >
                        {gif && 
                            <img src={gif} className={`object-cover w-full h-full ${hover?"visible":"invisible"}`}   alt="" />}
                        {/* {
                            (gif && hover) &&
                        <img src={gif} className="object-cover w-full h-full " alt="" />} */}
                    </div>

                </div>
                <div className="flex justify-center mt-1">
                    <h4 className="font-Bebasneue text-2xl tracking-wider">{title}</h4>
                </div>
            </div>
        </a>
    );
};

export default ProjectCard;